import React from 'react';
import { Calendar as DateRangeCalendar } from 'react-date-range';
import { ko } from 'react-date-range/dist/locale';

const Calendar = ({ onChange, date }) => {
  return <DateRangeCalendar locale={ko} date={date} onChange={onChange} />;
};

export default Calendar;
